<template>
    <div class="mt-2">
        <b-form-select
            v-model="option"
            :options="endOfExerciseOptions"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

import endOfExerciseOptions from '../../../common/data/endOfExerciseOptions.json'

export default {
    name: 'SelectEndOfExercise',

    mixins: [DataUpdater],
    data() {
        return {
            option: 0,
            endOfExerciseOptions,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
        }),

        selectClass() {
            return this.option === 0 ? 'bg-white' : 'selected-filter'
        },
    },

    async created() {
        this.option = this.filters.endOfExercise
    },

    methods: {
        async setFilter() {
            await this.$store.dispatch(
                'reportingVM/setEndOfExerciseFilter',
                this.option
            )
            this.$emit('end-of-exercise-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },
    },
}
</script>

<style scoped></style>
